import { render, staticRenderFns } from "./veSbzcCdInfoEdit.vue?vue&type=template&id=5b520dfe&scoped=true"
import script from "./veSbzcCdInfoEdit.vue?vue&type=script&lang=js"
export * from "./veSbzcCdInfoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b520dfe",
  null
  
)

export default component.exports